import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "hhn-commons";

import {
  CancelEditMessageButton,
  EditMessageContainer,
  EditMessageText,
} from "../MessagePanel.style";

type EditMessageBannerProps = {
  onCancel: () => void;
};

export const EditMessageBanner = ({ onCancel }: EditMessageBannerProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });

  return (
    <EditMessageContainer>
      <EditMessageText variant="subtitle1">
        {tNs("editingMessage")}
      </EditMessageText>

      <CancelEditMessageButton
        size="small"
        onClick={onCancel}
        data-testid="cancel-edit-message"
        aria-label={tNs("cancelEditingMessage")}
      >
        <CloseIcon />
      </CancelEditMessageButton>
    </EditMessageContainer>
  );
};
